/* eslint-disable no-inline-styles/no-inline-styles */
/* eslint-disable max-depth */
/* eslint-disable no-console */
/* eslint-disable spaced-comment */
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AssessmentStatusCodes, accountTypes, accountNames, controlTypes, assessmentTypes } from '../../StatusCodes/AssementStatusCodes';
import ButtonComponent from './ButtonCompnent';
import EventLogger from '../../Components/Common/DynamicForms/EventLogger';
import {
    updateCurrentIndex,
    clearAnswers,
    updateApiTokens,
    clearStore,
    updateLanguage,
    removeAPIDataAction,
    updateLanguageList,
    addZipcodeCountyListToStore
} from '../../Store/commonStore/actions';
import Loader from '../../Components/Common/Loader';
import { toast } from 'react-toastify';
import { autoSaveAnswers, submitAssessment } from '../../helpers/APIs/ApiEndPoints';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import NavbarComponent from '../../Components/Header/Navbar';
import Error500 from '../Errors/Error500';
import Unavailable from '../Errors/Unavailable';
import { getTenantConfig, isIOS } from '../../Components/Common/Util';

import {
    getAnsIdsForCheckBox,
    getPrapareResponse,
    checkAllenabledCheckboxHasValuesInPrapare,
    languageMapping,
    addQuestionIds,
    getAnswersForTextInputs,
    constructValue,
    checkVisibilityRule,
    checkForDisableRules,
    prepareRulesObj,
    handleSingleValue,
    handleMultipleValue,
    checkForSelectDeselect,
    prepareObjectForCategory,
    checkAnswerVisibleRule,
    checkIsMandate,
    getAnswerForDropdown,
    prepareQuestionMandate,
    filterEnableActions,
    processResponses,
    processHtmlContent,
    checkAnswerIdToDisableButton,
    handleAlertRules,
    getAllAnswers,
    languageMappingWithCode
} from './AssessmentServices';
import { Row, Label, Card, CardBody, Button } from 'reactstrap';
import FormElements from '../../Components/Common/DynamicForms/FormElements';
import { cloneDeep, isEmpty, debounce } from 'lodash';
import { APIClient } from '../../helpers/ApiHeleps';
// import { samApiToken } from '../Dashboard/utils';
import ConfirmationPopup from '../../Components/Common/ConfirmationPopup';
import { getConfig } from '@testing-library/react';
import { PRAPARE_INFO } from './Utils';
import CommonModal from '../../Components/Common/CommonModal';
import { SelectSearchValInStore } from '../../Store/commonStore/selectors';
function Index() {
    const userAgent = navigator;
    const deviceMode = navigator?.userAgentData;
    const resourceData = {
        mobile: deviceMode?.mobile,
        platform: deviceMode?.platform,
        browser: deviceMode?.brands?.[2]?.brand || ''
    };

    const getUserAgentInfo = () => {
        const userAgent = navigator.userAgent || '';
        const deviceMode = navigator.userAgentData || null;
        const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent) && !isIOSDevice;
        const isWindows = /Win32|Win64|Windows|WinCE/.test(userAgent);

        const getBrowserType = () => {
            if (/Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
                return 'Chrome';
            } else if (/Safari/.test(userAgent) && /Apple Computer/.test(navigator.vendor)) {
                return 'Safari';
            } else if (/Firefox/.test(userAgent)) {
                return 'Firefox';
            } else if (/MSIE|Trident/.test(userAgent)) {
                return 'Internet Explorer';
            } else if (/Edge/.test(userAgent)) {
                return 'Edge';
            } else {
                return 'Other';
            }
        };

        const browserType = getBrowserType();

        if (deviceMode) {
            // Handle modern browsers with userAgentData
            return {
                mobile: deviceMode.mobile ? 'iphone' : '',
                platform: deviceMode.platform || '',
                // userAgent: userAgent,
                isIOS: isIOSDevice,
                isMac: isMac,
                isWindows: isWindows,
                browserType: browserType
            };
        } else {
            // Fallback for older browsers or non-chromium based browsers
            return {
                mobile: isIOSDevice ? 'iphone' : '',
                platform: navigator.platform || '',
                // userAgent: userAgent,
                isIOS: isIOSDevice,
                isMac: isMac,
                isWindows: isWindows,
                browserType: browserType
            };
        }
    };

    const userAgentInfo = getUserAgentInfo();

    const { i18n } = useTranslation();
    const userCredential = useSelector((state) => state.CommonStore.loginToken);

    const [languagesList, setLanguagesList] = useState([]);
    const [unavailable, setUnavailabe] = useState(false);
    const [selectedLan, setSelectedLan] = useState('');
    const [assassmentCancelled, setAssessmentCancelled] = useState(false);
    const currentIndexFromStore = useSelector((state) => state.CommonStore.currentIndex);
    const currentLanguage = useSelector((state) => state.CommonStore.language);
    const { uniqueLinkId, memberId } = useParams();

    const dispatch = useDispatch();
    const location = useLocation();
    const tenantConfig = getTenantConfig(location?.pathname);

    const queryParams = new URLSearchParams(location.search);

    const firstname = queryParams?.get('firstname');
    const findhelpParam = queryParams?.get('findhelp');
    const findhelp = findhelpParam ? findhelpParam : '';
    const lang = queryParams?.get('lang');
    const lowerCaseLang = lang ? lang.toLocaleLowerCase() : 'en';

    let history = useHistory();
    const { t } = useTranslation();
    const api = new APIClient();

    const [questionsData, setQuestionsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [displayPosition, setDisplayPosition] = useState();
    const [assessmentContent, setHeaderContent] = useState({});
    const [dataNotFound, setDataNotFound] = useState(false);
    const [assessmentCompleted, setAssessmentCompleted] = useState(false);
    const [assessmentLength, setAssessmentLength] = useState(0);
    const [actionType, setActionType] = useState('next');
    const [selectedLanQns, setSelectedLanQna] = useState();
    const [assessmentData, setAssessmentData] = useState({});
    const [thankingPage, setThankingPage] = useState(false);
    const [questionRulesObj, setQuestionRulesObj] = useState({});
    const [answerLevelRulesObj, setAnswerLevelRulesObj] = useState({});
    const [showSubmitIfEmptyPage, setShowSubmitIfEmptyPage] = useState(false);
    const [updateTable, setUpdateTable] = useState(false);
    // const [isValidate, setIsValidate] = useState({ email: true, zipcode: true, mobile: true });
    const [generateNeedsForCategory, setGenerateNeedsForCategory] = useState([]);
    const [confirmPopup, setConfirmPopup] = useState('');
    const [btnForMarriot, setDisableBtnForMarriot] = useState(true);
    const [memberLevelRule, setMemberLevelRule] = useState();
    const [assessmentIdForBtn, setAssessmentId] = useState();
    const [fromDashboard, setFromDashboard] = useState(!isEmpty(userCredential));
    const [isFieldsAreValid, setIsValidate] = useState({});
    const [isSam, setIsSam] = useState(false);
    const [apiTokens, setTokens] = useState(isEmpty(userCredential) ? {} : userCredential);
    const [isNumValid, setAllFieldsValid] = useState(true);
    const [questionMandate, setQuestionMandate] = useState();
    const [nextToSubmit, setNextToSubmit] = useState(false);
    const [apiCalling, setApiCalling] = useState(false);
    const [dropVal, setDropVal] = useState({});

    const [disableContinueBtn, setDisableContinueBtn] = useState(true);
    // To check isActiveTemplate
    const [isInActiveTemplate, setIsInActiveTemplate] = useState(false);
    const [displayEligibilityConfirmation, setDisplayEligibilityConfirmation] = useState('');
    const [memberAlertRules, setMemberAlertRules] = useState({});
    const [dynamicOptions, setDynamicOptions] = useState([]);

    const counties = useSelector((state) => SelectSearchValInStore(state, 'zipcodeCountyList'));

    const fetchZipcodeAPI = async (token) => {
        try {
            const resp = await api.get('zipcode/counties', token, null, true);
            if (resp?.data?.isSuccess) {
                const zipCountyMap = {};
                resp?.data?.data?.length &&
                    resp?.data?.data?.forEach((item) => {
                        zipCountyMap[item.zipCode] = item.countyNames;
                    });
                addZipcodeCountyListToStore({ ...zipCountyMap });
            }
        } catch (err) {
            toast.error('Zipcode API is failed try again');
        }
    };
    useEffect(() => {
        dispatch(updateCurrentIndex(0));
        const fetchData = async (boolValue) => {
            if (!boolValue) {
                await authrizrFn();
            } else {
                fetchZipcodeAPI(apiTokens);
                getQuestionsData(apiTokens);
            }
        };
        fetchData(fromDashboard);
        return () => {
            !fromDashboard && dispatch(clearStore());
        };
    }, []);

    useEffect(() => {
        if (!fromDashboard) {
            removeAPIDataAction();
            dispatch(clearStore());
        }
    }, [fromDashboard]);

    const debouncedPopup = useCallback(
        debounce((msg) => {
            setDisplayEligibilityConfirmation(msg);
        }, 2000),
        []
    );

    // useEffect(() => {
    //     if (assessmentData?.token) {
    //         getQuestionsData();
    //     }
    // }, [apiTokens]);

    const handleApproveOrReject = async (type) => {
        let url = uniqueLinkId + '/' + type;
        try {
            setApiCalling(true);
            let resp = await api.update(url, apiTokens, null);
            if (resp?.data?.isSuccess && resp?.data?.data) {
                toast.success(`Assessment ${type === 'approve' ? 'Approved' : 'Rejected'} successfully`);
                setApiCalling(false);
                setConfirmPopup('');
                getQuestionsData(apiTokens);
            } else if (!resp?.data?.isSuccess) {
                toast.error(type + ' Api failing try again');
                setApiCalling(false);
                setConfirmPopup('');
            }
        } catch (err) {
            toast.error('Something went wrong please try again.');
            setApiCalling(false);
            setConfirmPopup('');
        }
    };

    const authrizrFn = async () => {
        if (uniqueLinkId) {
            try {
                let url = '';
                let authorize = await api.get(url, '', uniqueLinkId);
                if (authorize?.data?.data) {
                    let res = authorize.data.data;
                    // dispatch(updateApiTokens({ apiKey: res?.apiKey, token: res?.token }));
                    setTokens({ apiKey: res?.apiKey, token: res?.token });
                    let apiToken = { apiKey: res?.apiKey, token: res?.token };
                    fetchZipcodeAPI(apiToken);
                    getQuestionsData(apiToken);
                } else if (authorize?.data?.errorMessage !== null) {
                    toast.error(authorize?.data?.errorMessage?.[0]);
                    setLoading(false);
                    dispatch(updateApiTokens({ apiKey: '', token: null }));
                    setDataNotFound(true);
                }
                // setLoading(false);
                return authorize;
            } catch (error) {
                setLoading(false);
                dispatch(updateApiTokens({ apiKey: '', token: null }));
                setDataNotFound(true);
            }
        } else {
            return;
        }
    };

    const prepareDataFn = (queData, uniqueId, assessmentId, formType, answers, entireData) => {
        let questions = queData;
        questions = questions?.map((ques) => {
            let b = { ...ques };
            let findQues = answers?.find((ans) => ans.questionInternalId === ques.questionInternalIdentifier);
            if (b?.questionText && b.questionText.includes('[FIRSTNAME]')) {
                b.questionText = b.questionText.replace('[FIRSTNAME]', firstname || '');
            }

            let valueObj = {};
            if (b?.nestedQuestions?.formType === 'table') {
                const updatedNestQuestions = b?.nestedQuestions?.questions.map((nestques) => {
                    const findAns = answers?.find((ans) => ans.questionInternalId === nestques.questionInternalIdentifier);
                    return {
                        ...nestques,
                        value: findAns?.ansId ? +findAns.ansId : '',
                        answerInternalIdentifier: findAns?.answerInternalId,
                        textAns: findAns?.textQuesResponses || []
                    };
                });
                b.nestedQuestions = {
                    ...b?.nestedQuestions,
                    questions: updatedNestQuestions
                };
                setUpdateTable(true);
            }
            if (ques?.answers?.every((an) => an.answerControlType === 0 || an.answerControlType == null)) {
                //set answers for single answerControlType
                valueObj = handleSingleValue(b, findQues, ques);
            } else {
                // set answers for multiple answerControlType
                valueObj = handleMultipleValue(findQues, ques);
            }
            ques?.answerControlType === 127 &&
                valueObj?.textAns?.length &&
                valueObj?.textAns?.[0]?.answer?.length === 5 &&
                setDynamicOptions(counties[valueObj?.textAns?.[0]?.answer]);

            b.value = valueObj || '';
            return b;
        });
        let finalQues = { formType, questions, uniqueId, assessmentId };

        entireData?.assessment?.formtype === PRAPARE_INFO &&
            checkAnswerIdToDisableButton(entireData, questions, currentIndexFromStore, setDisableContinueBtn);

        setQuestionsData(finalQues);
        setLoading(false);
    };
    const setLanguageData = (entireData, language, currentIndex) => {
        let selectedLanguage = languageMapping[lowerCaseLang];
        let selectedLanguageQuestions = [];
        let lanuguagesArray = [];
        const questionnaire = entireData.assessment?.assessmentTemplate;
        if (!entireData?.isActiveTemplate) {
            lanuguagesArray = ['English', 'Español', 'العربية'];
            i18n.changeLanguage(selectedLanguage);
            localStorage.setItem('I18N_LANGUAGE', selectedLanguage);
            dispatch(updateLanguage(selectedLanguage));
            setSelectedLan(selectedLanguage);
        } else {
            if (language) {
                i18n.changeLanguage(language);
                localStorage.setItem('I18N_LANGUAGE', language);
                dispatch(updateLanguage(language));
                setSelectedLan(language);
                questionnaire.forEach((item) => {
                    item.formType = entireData?.assessment?.title;
                    lanuguagesArray.push(item.language);
                    if (item.language.toLowerCase() === language.toLowerCase()) selectedLanguageQuestions.push(item);
                });
            } else if (lowerCaseLang && languageMapping[lowerCaseLang]) {
                i18n.changeLanguage(selectedLanguage);
                localStorage.setItem('I18N_LANGUAGE', selectedLanguage);
                dispatch(updateLanguage(selectedLanguage));
                setSelectedLan(selectedLanguage);
                questionnaire.forEach((item) => {
                    item.formType = entireData?.assessment?.title;
                    lanuguagesArray.push(item.language);

                    if (item.language.toLowerCase() === selectedLanguage.toLowerCase()) selectedLanguageQuestions.push(item);
                });
                if (!selectedLanguageQuestions?.length) {
                    let qnsData = questionnaire?.find((item) => item?.default === 1);
                    selectedLanguageQuestions.push(qnsData);
                    i18n.changeLanguage(qnsData?.language);
                    localStorage.setItem('I18N_LANGUAGE', qnsData?.language);
                    dispatch(updateLanguage(qnsData?.language));
                    setSelectedLan(qnsData?.language);
                }
            } else {
                questionnaire.forEach((item) => {
                    lanuguagesArray.push(item.language);
                    if (item?.default === 1) {
                        i18n.changeLanguage(item.language);
                        selectedLanguageQuestions.push(item);
                        localStorage.setItem('I18N_LANGUAGE', item.language);
                        dispatch(updateLanguage(item.language));
                        setSelectedLan(item.language);
                    }
                });
            }
        }

        setLanguagesList(lanuguagesArray);
        dispatch(updateLanguageList(lanuguagesArray));
        const replaceFinderHelp = selectedLanguageQuestions[0]?.headerTemplate.replace('[FINDHELP]', findhelp || '');
        const cleanedHeaderTemplate = replaceFinderHelp?.replace(/^"|"$/g, '');
        const headerWithUrl = cleanedHeaderTemplate?.replace('{baseURL}', process.env.REACT_APP_IMG_URL);
        const assessmentFooter = selectedLanguageQuestions[0]?.footerTemplate.replace(/^"|"$/g, '');
        const footerWithUrl = assessmentFooter?.replace('{baseURL}', process.env.REACT_APP_IMG_URL);

        document.title = selectedLanguageQuestions[0]?.name || 'Assessor';
        setHeaderContent({ headerWithUrl, footerWithUrl });

        const { uniqueLink: uniqueId, assessmentId, responses } = entireData;
        const answers = responses || [];
        setAssessmentLength(selectedLanguageQuestions[0]?.questionaireTemplate.length);
        let qnsData = selectedLanguageQuestions[0]?.questionaireTemplate;
        let qndDataForId = addQuestionIds(qnsData, questionRulesObj, assessmentData);
        let questions;
        if (currentIndex === 0) {
            questions = qndDataForId[currentIndex].innerQuestionaireTemplate || [];
        } else {
            questions = qndDataForId[currentIndexFromStore].innerQuestionaireTemplate || [];
        }
        setSelectedLanQna(selectedLanguageQuestions[0]);
        if (questions?.length > 0) setDisplayPosition(selectedLanguageQuestions[0]?.config?.textAlignment);

        // prepareDataFn(questions, uniqueId, assessmentId, entireData?.assessment?.title, answers, currentIndexFromStore);
        prepareDataFn(questions, uniqueId, assessmentId, entireData?.assessment?.title, answers, entireData);
    };

    const getQuestionsData = async (apiToken) => {
        setLoading(true);
        try {
            let url = isSam ? 'approval' + location?.pathname : `${uniqueLinkId}/${memberId}`;
            let response = await api.get(url, apiToken);

            // let response = await api.get(`${uniqueLinkId}/${memberId}`, apiToken); //&& response.data.isSuccess
            if (response.status === 200 && response.data.isSuccess) {
                setIsInActiveTemplate(!response?.data?.data?.isActiveTemplate);
                const entireData = response?.data?.data;

                const refDropVal = entireData?.responses?.[0]?.dropdownAns.filter((item) =>
                    ['Caregiver/Representative', 'Human Resources', 'Health Coach', 'GGH Care Coordinator'].includes(item.label)
                );
                setDropVal(refDropVal?.length > 0 ? refDropVal?.[0] : {});

                // set questionLevelRules and answerLevelRules as a map based on question number
                let { questionRules, answerLevelRules, memberLevelRule, memberLevelAlertRules } = prepareRulesObj(entireData);
                let getQuestionMandate = prepareQuestionMandate(entireData);
                setQuestionMandate(getQuestionMandate);
                setQuestionRulesObj(questionRules);
                setAnswerLevelRulesObj(answerLevelRules);
                setMemberLevelRule(memberLevelRule);
                setMemberAlertRules(memberLevelAlertRules);

                setIsSam(entireData?.role === accountTypes.Sam);
                if (entireData?.status === AssessmentStatusCodes.Completed && entireData?.role === accountTypes.Assessor) {
                    setAssessmentCompleted(true);
                } else if (
                    entireData?.role === accountTypes.Sam &&
                    (entireData?.status === AssessmentStatusCodes.Approved ||
                        entireData?.status === AssessmentStatusCodes.Rejected ||
                        entireData?.status === AssessmentStatusCodes?.SamSubmitted)
                ) {
                    setAssessmentCompleted(true);
                } else if (entireData?.status === AssessmentStatusCodes.Abort || entireData?.status === AssessmentStatusCodes.Pause) {
                    setAssessmentCancelled(true);
                    return;
                }

                setAssessmentData(entireData);
                setAssessmentId(entireData?.assessmentInternalId);
                let currentIndex = 0;
                let categoryObjArr = prepareObjectForCategory(entireData?.assessment?.carePlanTemplate);
                categoryObjArr?.length && setGenerateNeedsForCategory([...categoryObjArr]);
                setLanguageData(entireData, '', currentIndex);
            } else if (response.data.isSuccess === false) {
                setUnavailabe(true);

                // setDataNotFound(true);
            }
        } catch (err) {
            // setLoading(false);
            setDataNotFound(true);
            dispatch(updateCurrentIndex(0));
            dispatch(clearAnswers([]));
        } finally {
            setLoading(false);
        }
    };
    const saveAnswers = async (data) => {
        try {
            let response = await api.create(
                `${assessmentData?.assessmentSentId}/${autoSaveAnswers}`,
                apiTokens,
                data,
                JSON.stringify(userAgentInfo)
            );
        } catch (err) {}
    };
    const assessmentSubmitionCall = async (url) => {
        if (assessmentCompleted) return;
        setLoading(true);
        try {
            let responseSource = { ...userAgentInfo, language: currentLanguage };
            let submitUrl;
            if (assessmentData?.role === accountTypes?.Sam) {
                submitUrl = `${assessmentData?.assessmentSentId}/${accountNames.sam}/${url}`;
            } else {
                submitUrl = `${assessmentData?.assessmentSentId}/${url}`;
            }
            let response = await api.update(submitUrl, apiTokens, responseSource);
            if (response?.data?.isSuccess === true) {
                setLoading(false);
                setAssessmentCompleted(true);
                localStorage.removeItem('I18N_LANGUAGE');
                localStorage.removeItem('i18nextLng');
                if (selectedLanQns?.confirmationPageContent) {
                    // removeAPIDataAction();
                    // dispatch(clearStore());
                    setThankingPage(true);
                    return;
                }
                if (assessmentIdForBtn.toString() === tenantConfig?.REACT_APP_ASSESSMENT_ID && assessmentData?.role !== accountTypes?.Sam) {
                    return history.replace('/assessment');
                }
                let redirectUrl = assessmentData?.redirectUrl;
                // Check if redirectUrl does not start with 'https://'
                if (redirectUrl && !redirectUrl.startsWith('https://')) {
                    redirectUrl = `https://${redirectUrl}`;
                }
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                } else {
                    history.replace('/assessmentCompleted');
                }
                // removeAPIDataAction();
                // dispatch(clearStore());
            } else {
                toast.error(t('submitError'));

                return false;
            }
        } catch (err) {
            // console.log('errr', err);
            toast.error(t('submitError'));
        } finally {
        }
    };

    // useEffect(() => {
    // 	return
    // })

    useEffect(() => {
        if (assessmentData?.assessment?.title) {
            const { uniqueLink: uniqueId, assessmentId, responses } = assessmentData;
            let formType = assessmentData.assessment?.title;
            // const qns = selectedLanQns?.questionaireTemplate[currentIndexFromStore].innerQuestionaireTemplate;
            let qnsData = selectedLanQns?.questionaireTemplate;
            let qndDataForId = addQuestionIds(qnsData, questionRulesObj, assessmentData);
            let questions = qndDataForId?.[currentIndexFromStore]?.innerQuestionaireTemplate || [];
            // ******************* logic to skip empty page ***************
            let isVisible = questions.some(function (item) {
                return checkVisibilityRule(item, questionRulesObj, assessmentData) === true;
            });
            // setShowSubmitIfEmptyPage(false);
            if (!isVisible && questions.length > 0) {
                currentIndexFromStore !== assessmentLength - 1 && actionType === 'next' && handleNext();
                currentIndexFromStore !== assessmentLength - 1 && actionType === 'prev' && handlePrev();
                currentIndexFromStore === assessmentLength - 1 && setShowSubmitIfEmptyPage(true);
            }
            if (questions?.length === 1 && !isVisible && !assessmentCompleted) {
                return setThankingPage(true);
            } else {
                setThankingPage(false);
            }
            // ******************* logic to skip empty page ***************

            // setSelectedLanQna(selectedLanguageQuestions[0]);

            // prepareDataFn(questions, uniqueId, assessmentId, formType, responses, currentIndexFromStore);
            prepareDataFn(questions, uniqueId, assessmentId, formType, responses, assessmentData);
        }
    }, [currentIndexFromStore]); //, assessmentData, selectedLanQns, questionRulesObj, questionsData

    // language change function
    const changeLanguage = (selectedLanguage) => {
        dispatch(updateLanguage(selectedLanguage));
        setSelectedLan(selectedLanguage);
        const { uniqueLink: uniqueId, assessmentId, responses } = assessmentData;
        // console.log('res=-=-', responses);

        if (!isInActiveTemplate) setLanguageData(assessmentData, selectedLanguage);
    };

    // event on save click for all(autosave, completion save & offline store save)
    const handleSave = (isSubmitted = '', tempQuestionsData = questionsData, reference) => {
        let quesRes = getPrapareResponse(tempQuestionsData, isSubmitted, []);
        let updatedData = {};
        let immediateRes;
        setAssessmentData((prevData) => {
            // Copy previous data
            updatedData = { ...prevData };
            if (updatedData.responses && updatedData.responses.length > 0) {
                quesRes.forEach((newResponse) => {
                    let existingIndex = updatedData.responses.findIndex(
                        (existingResponse) => existingResponse.questionInternalId === newResponse.questionInternalId
                    );
                    if (existingIndex !== -1) {
                        updatedData.responses[existingIndex] = newResponse;
                    } else {
                        updatedData.responses.push(newResponse);
                    }
                });
            } else {
                updatedData.responses = quesRes;
                immediateRes = quesRes;
            }

            // ***************** remove invisible questions from response *****************
            try {
                let allQuestions = [];
                if (selectedLanQns?.questionaireTemplate?.length > 0) {
                    selectedLanQns?.questionaireTemplate.forEach((item) => {
                        if (item?.innerQuestionaireTemplate) {
                            allQuestions.push(...item.innerQuestionaireTemplate);
                        }
                    });
                }
                let visibleQuestionResponses = [];
                if (updatedData?.responses?.length > 0) {
                    visibleQuestionResponses = updatedData.responses.filter((upresp) => {
                        let item = null;
                        if (allQuestions?.length > 0) {
                            item = allQuestions.find((q) => q.questionInternalIdentifier === upresp.questionInternalId);
                        }

                        // Directly return item if it has nestedQuestions not null
                        if (item?.nestedQuestions !== null) {
                            return true;
                        }

                        return item ? checkVisibilityRule(item, questionRulesObj, assessmentData) === true : false;
                    });
                }
                updatedData.responses = visibleQuestionResponses;
                immediateRes = visibleQuestionResponses;
            } catch (error) {
                console.error('Error in filtering visible questions:', error);
            }
            // ***************** remove invisible questions from response *****************

            const filteredArr = updatedData?.responses?.filter((item) => {
                if (item.ansId !== null) {
                    if (item?.TextQuesResponses?.length > 0) {
                        return item?.TextQuesResponses?.every((response) => response?.Answer !== '');
                    } else {
                        return true;
                    }
                }
                return false;
            });

            let dataObj = {
                quesResponses: filteredArr,
                isAssessmentCompleted: false,
                score: 0,
                assessmentId: questionsData?.assessmentId,
                ResponseSource: JSON.stringify(userAgentInfo)
            };
            // if (assessmentData?.data?.status !== AssessmentStatusCodes?.SamSubmitted) {
            !assessmentCompleted && saveAnswers(dataObj);
            // }
            return updatedData;
        });
        // console.log('updatedData', assessmentData);
        let qnsData = selectedLanQns?.questionaireTemplate;
        const questions = qnsData?.[currentIndexFromStore + 1]?.innerQuestionaireTemplate || [];
        // const questions = qnsData.slice(currentIndexFromStore + 1);

        if (questions?.length && assessmentData?.assessmentInternalId === assessmentTypes?.AHC) {
            setNextToSubmit(false);

            setShowSubmitIfEmptyPage(false);
            let isVisible = questions.some(function (item) {
                return checkVisibilityRule(item, questionRulesObj, assessmentData, immediateRes) === true;
            });
            if (!isVisible) {
                let mandate = true;
                let validateQnsAnswer = checkAllenabledCheckboxHasValuesInPrapare(
                    questionsData,
                    questionRulesObj,
                    assessmentData,
                    questionMandate,
                    mandate,
                    immediateRes
                );
                if (validateQnsAnswer?.length) {
                    // setShowSubmitIfEmptyPage(false);
                    return setNextToSubmit(false);

                    // return toast.error('Please answer the question.');
                } else {
                    // console.log('asasasas');
                    // setShowSubmitIfEmptyPage(true);
                    setNextToSubmit(true);

                    // return assessmentSubmitionCall(submitAssessment);
                }
                // setThankingPage(true);
            }
        }
    };

    const handleValidation = () => {
        let submitCall = '';
        let disableQuestions = checkAllenabledCheckboxHasValuesInPrapare(questionsData, questionRulesObj, assessmentData, questionMandate);
        if (disableQuestions?.length) {
            toast.error(t('assessmentNotCompletedMsg'));
            return false;
        } else {
            if (currentIndexFromStore !== assessmentLength - 1) {
                return true;
            } else {
                return (submitCall = 'submit');
                //api call
                // dispatch(updateCurrentIndex(0));
                // dispatch(clearAnswers([]));
            }
        }
    };
    const handleOnBlurEvent = (isValid, type) => {
        if ((isValid === true || isValid === false) && type) {
            setIsValidate((prevState) => {
                const updatedState = {
                    ...prevState,
                    [type]: isValid
                };

                const allTrue = Object.values(updatedState).every((value) => value === true);

                setAllFieldsValid(allTrue);

                return updatedState;
            });
        }
        handleSave();
    };

    const inputChangeCommonCode = (updatedField, index, type) => {
        let tempQuestionsData = { ...questionsData };
        const updatedFields = [...questionsData?.questions];
        updatedFields[index] = updatedField;

        tempQuestionsData.questions = updatedFields;
        checkAnswerIdToDisableButton(assessmentData, tempQuestionsData.questions, currentIndexFromStore, setDisableContinueBtn);

        setQuestionsData(tempQuestionsData);
        let isIos = isIOS();
        if (isIos || type === 112 || type === 109 || type === 121 || type === 104) {
            handleSave('', tempQuestionsData);
        }
        return tempQuestionsData;
    };

    // preapaning data for input change for radio, checkbox, dropdown, text, date etc.,
    const handleInputChange = (updatedValue, field, index, ansItem, event) => {
        // checkForDisableRules(field, ansItem, answerLevelRulesObj);
        const updatedField = cloneDeep(field);
        let valueObj = field?.value || {};
        let type = field?.nestedQuestions?.formType || ansItem?.answerControlType || field?.answerControlType;
        let ansInternalIdForNeed = ansItem?.answerInternalIdentifier || updatedValue?.value;
        let showToastMessage = typeof updatedValue === 'object' ? false : true;
        switch (type) {
            case 106:
            case 114:
                if (valueObj['radioAns'] === updatedValue) {
                    // If the same radio button is clicked again, deselect it
                    valueObj['radioAns'] = null;
                } else {
                    valueObj['radioAns'] = updatedValue;
                }
                setTimeout(() => {
                    handleSave();
                }, 100);
                break;
            case 108:
            case 118:
            case 105:
            case 119:
            case 111:
            case 115:
            case 116:
            case 123:
            case 127:
            case 122:
            case 117:
            case 109:
            case 121:
            case 112:
            case 124:
            case 126:
            case 128:
                valueObj['textAns'] = getAnswersForTextInputs(field, updatedValue, ansItem);
                break;
            case 104:
                valueObj['checkboxAns'] = getAnsIdsForCheckBox(field, updatedValue);
                showToastMessage = updatedValue?.checked;
                // setTimeout(() => {
                //     handleSave();
                // }, 2000);
                break;
            case 103:
            case 120:
            case 125:
                valueObj['dropdownAns'] = getAnswerForDropdown(field, updatedValue, ansItem);
                setDropVal(updatedValue);
                break;
            case 'table':
                valueObj['tableAns'] = updatedValue;
                setTimeout(() => {
                    handleSave();
                }, 1000);
                break;
            default:
                break;
        }
        let filteredVal = checkForSelectDeselect(
            field,
            ansItem,
            answerLevelRulesObj,
            valueObj,
            setDisableContinueBtn,
            assessmentData?.assessment
        );

        updatedField.value = filteredVal;
        inputChangeCommonCode(updatedField, index, type);

        // let checkChooseNotToAnswer = field?.answers?.find((e) => e?.answerText === 'I choose not to answer');
        // let needsArr = generateNeedsForCategory?.filter((item) => item?.ansInternalId?.includes(ansInternalIdForNeed));
        // if (
        //     needsArr?.length &&
        //     showToastMessage &&
        //     isSam &&
        //     !valueObj['checkboxAns']?.includes(checkChooseNotToAnswer?.answerInternalIdentifier)
        // ) {
        //     let needs = needsArr?.map((e) => e?.needSubCategoryName)?.join(',');
        //     toast.info(`${needs} ${needsArr?.length > 1 ? 'needs' : 'need'} triggered.`);
        // }

        // Below line is for show popup
        const popUpMsg = handleAlertRules(
            memberAlertRules,
            updatedField,
            getAllAnswers(updatedField),
            languageMappingWithCode[selectedLan]
        );
        !!popUpMsg && debouncedPopup(popUpMsg);
    };

    const handleAssessmentSubmit = () => {
        if (assessmentCompleted) return;
        const checkValidation = handleValidation();
        const answerRules = answerLevelRulesObj;
        const allAnswerResponses = assessmentData?.responses;

        // Get the filtered result
        const enableActions = filterEnableActions(answerRules);

        // if (assessmentIdForBtn.toString() === tenantConfig?.REACT_APP_ASSESSMENT_ID) {
        const matchedResponses = processResponses(allAnswerResponses, enableActions);
        if (matchedResponses?.length >= 1) {
            return toast.error(t('textboxErrorMsg'));
        }
        // }
        if (!isNumValid) {
            return toast.error(t('enterValidAnswer'));
        }

        if (assessmentData?.assessmentInternalId === assessmentTypes?.AHC) {
            let mandate = true;
            let validateQnsAnswer = checkAllenabledCheckboxHasValuesInPrapare(
                questionsData,
                questionRulesObj,
                assessmentData,
                questionMandate,
                mandate
            );
            if (validateQnsAnswer?.length) {
                return toast.error(t('answerQuestion'));
            }
        }
        if (checkValidation) {
            const qnData = questionsData?.questions;
            const { uniqueLink: uniqueId, assessmentId, responses } = assessmentData;
            if (responses?.length > 0) {
                assessmentSubmitionCall(submitAssessment);
            } else {
                return toast.error(t('assessmentNotCompletedMsg'));
            }
        }
    };

    const handlePrev = () => {
        const answerRules = answerLevelRulesObj;
        const allAnswerResponses = assessmentData?.responses;

        // Get the filtered result
        const enableActions = filterEnableActions(answerRules);

        // if (assessmentIdForBtn.toString() === tenantConfig?.REACT_APP_ASSESSMENT_ID) {
        const matchedResponses = processResponses(allAnswerResponses, enableActions);
        if (matchedResponses?.length >= 1) {
            return toast.error(t('textboxErrorMsg'));
        }
        // }
        if (!isNumValid) {
            return toast.error(t('enterValidAnswer'));
        }
        setShowSubmitIfEmptyPage(false);
        setNextToSubmit(false);

        document.body.scrollTop = document.documentElement.scrollTop = 0;
        setActionType('prev');
        dispatch(updateCurrentIndex(currentIndexFromStore - 1));
        setDisableContinueBtn(false);
    };

    const handleNext = () => {
        // if (assessmentCompleted) return;
        let checkInputValication;
        if (assessmentData?.assessmentInternalId !== assessmentTypes?.AHC) {
            checkInputValication = handleValidation();
        }
        let demographicInfoAssmt = assessmentIdForBtn.toString() === getTenantConfig(assessmentIdForBtn)?.REACT_APP_ASSESSMENT_ID;
        if (demographicInfoAssmt) {
            const qnData = questionsData?.questions;
            const { responses } = assessmentData;

            const findQnId = qnData[0];
            let dropDownVal = [];

            let textAns = [];
            let allAns = [];
            let hcidAns;
            let mcidAns;
            if (findQnId?.value?.dropdownAns && findQnId?.value?.dropdownAns?.length) {
                findQnId?.value?.dropdownAns?.forEach((item) => {
                    dropDownVal.push(item?.answerInternalIdentifier);
                });
            }
            if (findQnId?.value?.textAns) {
                findQnId?.value?.textAns.forEach((item) => {
                    if (item?.answer) {
                        textAns.push(item?.answerInternalId);
                    }
                    if (item?.answerInternalId === controlTypes.hcid) {
                        hcidAns = item.answer;
                    }
                    if (item?.answerInternalId === controlTypes?.mcid) {
                        mcidAns = item.answer;
                    }
                });
            }
            // if (hcidAns === mcidAns && isSam) {
            //     return toast.error('HCID and MCID should not be the same.');
            // }

            allAns = [...textAns, ...dropDownVal];
            // if (dropDownVal) {
            //     allAns.push(10112);
            // }
            const mandatoryAnswerIds = memberLevelRule[1].rule.flatMap((rule) =>
                rule.role.includes(assessmentData?.role) && rule.action === 'Mandatory' ? rule.answerInternalIdentifier : []
            );

            const isFilledAll = mandatoryAnswerIds.every((ans) => {
                const result = allAns.includes(ans);
                return result;
            });

            if (isFilledAll && isNumValid) {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                // Based on the assessmet
                let checkCondition = assessmentData?.assessment?.formtype === PRAPARE_INFO ? !isSam : false;
                setActionType('next');
                setDisableBtnForMarriot(checkCondition);
                dispatch(updateCurrentIndex(currentIndexFromStore + 1));
                setDisableContinueBtn(false);
            } else {
                return toast.error('Fill mandatory feilds');
            }
        }
        const answerRules = answerLevelRulesObj;
        const allAnswerResponses = assessmentData?.responses;

        // Get the filtered result
        const enableActions = filterEnableActions(answerRules);

        // if (assessmentIdForBtn.toString() === tenantConfig?.REACT_APP_ASSESSMENT_ID) {
        const matchedResponses = processResponses(allAnswerResponses, enableActions);
        if (matchedResponses?.length >= 1) {
            return toast.error(t('textboxErrorMsg'));
        }
        let qnsData = selectedLanQns?.questionaireTemplate;
        const questions = qnsData?.[currentIndexFromStore + 1]?.innerQuestionaireTemplate || [];
        // const questions = qnsData.slice(currentIndexFromStore + 1);

        if (questions?.length && assessmentData?.assessmentInternalId === 65536) {
            let isVisible = questions.some(function (item) {
                return checkVisibilityRule(item, questionRulesObj, assessmentData) === true;
            });

            if (!isVisible) {
                let mandate = true;
                let validateQnsAnswer = checkAllenabledCheckboxHasValuesInPrapare(
                    questionsData,
                    questionRulesObj,
                    assessmentData,
                    questionMandate,
                    mandate
                );
                if (validateQnsAnswer?.length) {
                    return toast.error(t('answerQuestion'));
                } else {
                    if (!isNumValid) {
                        return toast.error(t('enterValidAnswer'));
                    }
                    checkInputValication = true;
                    return assessmentSubmitionCall(submitAssessment);
                }
                // setThankingPage(true);
            } else {
                checkInputValication = true;
            }
        }
        // setShowSubmitIfEmptyPage(false);

        // }
        if (checkInputValication) {
            if (!isNumValid) {
                return toast.error(t('enterValidAnswer'));
            }
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            setActionType('next');
            dispatch(updateCurrentIndex(currentIndexFromStore + 1));
        } else {
            return;
        }
    };
    const handleDone = () => {
        let redirectUrl = assessmentData?.redirectUrl;
        // Check if redirectUrl does not start with 'https://'
        if (redirectUrl && !redirectUrl.startsWith('https://')) {
            redirectUrl = `https://${redirectUrl}`;
        }
        if (redirectUrl) {
            window.location.href = redirectUrl;
        } else {
            history.replace('/assessmentCompleted');
        }
        // removeAPIDataAction();
        // dispatch(clearStore());
    };

    const resetIndex = () => {
        dispatch(updateCurrentIndex(0));
    };

    const handleError = () => {
        return (
            <div className="text-center m-5">
                <div className="alert alert-warning" role="alert">
                    <h2 className="mb-0">{isInActiveTemplate ? t('isInActiveTemplateMsg') : t('errorMsg')}</h2>
                </div>
            </div>
        );
    };

    const pageHeaderWithName = () => {
        let pageHeaderTemplate = selectedLanQns?.questionaireTemplate[currentIndexFromStore]?.pageHeaderTemplate;
        let pageHeader = pageHeaderTemplate?.replace('[FIRSTNAME]', firstname || '');
        let addFindHelp = pageHeader?.replace('[FINDHELP]', findhelp || '');
        // pageHeader = pageHeaderTemplate.replace('[FINDHELP]', findhelp || '');
        return (
            <div
                className="question-header"
                style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                dangerouslySetInnerHTML={{
                    __html: addFindHelp
                }}
            ></div>
        );
    };

    const pageFooterContent = () => {
        let pageFooterTemplate = selectedLanQns?.questionaireTemplate[currentIndexFromStore]?.pageFooterTemplate;
        let pageHeader = pageFooterTemplate?.replace('[FIRSTNAME]', firstname || '');
        let pageFooter = pageHeader?.replace('[FINDHELP]', findhelp || '');
        // pageHeader = pageHeaderTemplate.replace('[FINDHELP]', findhelp || '');
        return (
            <div
                className="question-header"
                dangerouslySetInnerHTML={{
                    __html: pageFooter
                }}
            ></div>
        );
    };

    const checkLabel = (item) => {
        if (item.answerControlType === 106 || item.answerControlType === 103 || item.answerControlType === 120) {
            return (
                <span
                    className={`badge ${displayPosition === 'right' ? 'badge-label-left' : 'badge-label'} badge-gradient-danger pt-2 pb-2`}
                >
                    {t('singleSelector')}
                </span>
            );
        }
        if (item.answerControlType === 104) {
            return (
                <span
                    className={`badge ${displayPosition === 'right' ? 'badge-label-left' : 'badge-label'} badge-gradient-danger pt-2 pb-2`}
                >
                    {t('multiSelector')}
                </span>
            );
        }
    };

    const questionHeadeTemplater = (item) => {
        const header = item?.questionHeaderTemplate.replace('[FINDHELP]', findhelp || '');
        return (
            <div
                className="assessment-question-header"
                style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                dangerouslySetInnerHTML={{
                    __html: header
                }}
            ></div>
        );
    };

    const handleRecall = () => {
        const qnData = questionsData?.questions;
        const { responses } = assessmentData;

        const findQnId = qnData[0];
        let dropDownVal = [];

        let textAns = [];
        let allAns = [];
        if (findQnId?.value?.dropdownAns) {
            findQnId?.value?.dropdownAns?.forEach((item) => {
                dropDownVal.push(item?.answerInternalIdentifier);
            });
        }
        if (findQnId?.value?.textAns) {
            findQnId?.value?.textAns.forEach((item) => {
                if (item?.answer) {
                    textAns.push(item.answerInternalId);
                }
            });
        }

        allAns = [...textAns, ...dropDownVal];
        // if (dropDownVal) {
        //     allAns.push(10112);
        // }
        const mandatoryAnswerIds = memberLevelRule[1].rule.flatMap((rule) =>
            rule.role.includes(assessmentData?.role) && rule.action === 'Mandatory' ? rule.answerInternalIdentifier : []
        );

        const isFilledAll = mandatoryAnswerIds.every((ans) => {
            const result = allAns.includes(ans);
            return result;
        });

        if (isFilledAll && isNumValid) {
            history.replace('/assessment');
        } else {
            return toast.error('Fill mandatory feilds');
        }
        // }
        // removeAPIDataAction();
        // dispatch(clearStore());
    };

    const isAnswerControlTypeValid = (type) => [0, 104, 106].includes(type);

    const isItemControlTypeValid = (type) => [120, 104, 106].includes(type);

    const shouldCheckLabel = (item) => {
        const allAnswersValid = item?.answers?.every((an) => isAnswerControlTypeValid(an.answerControlType));

        const itemControlTypeValid = isItemControlTypeValid(item?.answerControlType);

        return allAnswersValid || itemControlTypeValid;
    };

    const getVisibleQuestionNumber = (questions, currentIndex) => {
        let visibleNumber = 0;
        for (let i = 0; i <= currentIndex; i++) {
            if (checkVisibilityRule(questions[i], questionRulesObj, assessmentData)) {
                visibleNumber++;
            }
        }
        return visibleNumber;
    };

    const getVisibleQuestionNumberForAssessor = (questions, currentIndex) => {
        let visibleNumber = 0;
        for (let i = 0; i <= currentIndex; i++) {
            if (
                checkVisibilityRule(questions[i], questionRulesObj, assessmentData) &&
                !(questions[i]?.questionText?.includes('demographic information') || questions[i]?.questionText?.includes('demográficos'))
            ) {
                visibleNumber++;
            }
        }
        return visibleNumber;
    };

    const formForAssessor = () => {
        return (
            <Card className={`mx-3 mt-4 ${displayPosition === 'right' ? 'arabic-text' : ''}`}>
                <CardBody className="mt-4">
                    {questionHeader() && pageHeaderWithName()}
                    {questionsData?.questions?.length > 0 &&
                        questionsData.questions.map((item, index) => {
                            const hasTable = item?.questionHeaderTemplate?.includes('<table');
                            const visibleQuestionNumber = getVisibleQuestionNumberForAssessor(questionsData.questions, index);
                            return (
                                <React.Fragment key={index}>
                                    {checkVisibilityRule(item, questionRulesObj, assessmentData) && (
                                        <>
                                            {item?.answerControlType ? (
                                                <div className="custom-question-box-bg p-3 my-3 rounded-3">
                                                    <div
                                                        className={`assessment-question-header ${hasTable ? 'override-table-styles' : ''}`}
                                                        style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: processHtmlContent(item?.questionHeaderTemplate)
                                                        }}
                                                    ></div>
                                                    <Label
                                                        className="form-label infoLabel"
                                                        style={displayPosition === 'right' ? { marginRight: '8px' } : {}}
                                                    >
                                                        {/* <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: `
                <span style="margin-left: ${displayPosition === 'right' ? '12px' : '0'};">
                    ${item.qnId ? `${item.qnId}. ` : ''}
                    ${item.questionText}
                </span>
    			`
                                                            }}
                                                        /> */}
                                                        <span style={{ marginLeft: displayPosition === 'right' ? '12px' : '0' }}>
                                                            {item.qnId ? `${item.qnId}. ` : ''}
                                                            <span dangerouslySetInnerHTML={{ __html: item.questionText }} />
                                                            {item.isMandate && <span className="text-danger">*</span>}
                                                            {item.answers?.length !== 1 &&
                                                                shouldCheckLabel(item) &&
                                                                item.qnId &&
                                                                checkLabel(item)}
                                                        </span>
                                                    </Label>
                                                    {/* <Label>
                                                        {item.isMandate ? <span class="text-danger">*</span> : ''}
                                                        {item?.answers?.length !== 1 && shouldCheckLabel(item) && item.qnId
                                                            ? checkLabel(item)
                                                            : ''}
                                                    </Label> */}
                                                    {item?.nestedQuestions?.formType === 'table' ? (
                                                        <FormElements
                                                            key={index}
                                                            type={item?.nestedQuestions?.formType}
                                                            {...item}
                                                            changed={(e) => {
                                                                handleInputChange(e, item, index);
                                                            }}
                                                            handleOnBlur={(e) => {
                                                                if (assessmentCompleted) return;
                                                                else {
                                                                    return;
                                                                }
                                                                // handleOnBlurEvent();
                                                            }}
                                                            displayPosition={displayPosition}
                                                            data={item?.nestedQuestions}
                                                            disable={
                                                                assessmentCompleted ||
                                                                checkForDisableRules(item, null, answerLevelRulesObj, dropVal)
                                                            }
                                                            value={constructValue(item)}
                                                            updateTable={updateTable}
                                                            setUpdateTable={setUpdateTable}
                                                            answerLevelRulesObj={answerLevelRulesObj}
                                                            memberLevelRule={memberLevelRule}
                                                            assessmentData={assessmentData}
                                                        />
                                                    ) : item?.answerControlType === 103 || item.answerControlType === 120 ? (
                                                        <>
                                                            <Row className="g-3 mb-4 me-1">
                                                                <FormElements
                                                                    key={index}
                                                                    templateType={questionsData?.formType}
                                                                    type={item.answerControlType}
                                                                    {...item}
                                                                    changed={(e) => {
                                                                        handleInputChange(e, item, index);
                                                                    }}
                                                                    handleOnBlur={(e) => {
                                                                        if (assessmentCompleted) return;
                                                                        handleOnBlurEvent();
                                                                    }}
                                                                    displayPosition={displayPosition}
                                                                    disable={
                                                                        assessmentCompleted ||
                                                                        checkForDisableRules(item, null, answerLevelRulesObj, dropVal)
                                                                    }
                                                                    value={constructValue(item)}
                                                                    assessmentData={assessmentData}
                                                                />
                                                            </Row>
                                                            {item.questionFooterTemplate && (
                                                                <div
                                                                    className="assessment-question-header"
                                                                    style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item.questionFooterTemplate
                                                                    }}
                                                                ></div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Row className="g-3 me-2">
                                                                {item?.answers?.length > 0 &&
                                                                    item.answers.map(
                                                                        (ansItem) =>
                                                                            checkAnswerVisibleRule(
                                                                                assessmentData?.role,
                                                                                memberLevelRule,
                                                                                ansItem?.answerInternalIdentifier
                                                                            ) && (
                                                                                <>
                                                                                    <Label
                                                                                        style={
                                                                                            displayPosition === 'right'
                                                                                                ? { marginRight: '8px' }
                                                                                                : {}
                                                                                        }
                                                                                    >
                                                                                        {(ansItem?.answerHeaderText !== null ||
                                                                                            ansItem?.answerHeaderText !== '') &&
                                                                                            ansItem?.answerHeaderText}
                                                                                    </Label>
                                                                                    <FormElements
                                                                                        key={ansItem.answerId}
                                                                                        templateType={questionsData?.formType}
                                                                                        type={
                                                                                            ansItem.answerControlType ||
                                                                                            item.answerControlType
                                                                                        }
                                                                                        {...ansItem}
                                                                                        changed={(e, event) =>
                                                                                            handleInputChange(
                                                                                                e,
                                                                                                item,
                                                                                                index,
                                                                                                ansItem,
                                                                                                event
                                                                                            )
                                                                                        }
                                                                                        handleOnBlur={(isValid, type) => {
                                                                                            if (!assessmentCompleted) {
                                                                                                handleOnBlurEvent(isValid, type);
                                                                                            }
                                                                                        }}
                                                                                        displayPosition={displayPosition}
                                                                                        disable={
                                                                                            assessmentCompleted ||
                                                                                            checkForDisableRules(
                                                                                                item,
                                                                                                ansItem,
                                                                                                answerLevelRulesObj,
                                                                                                dropVal
                                                                                            )
                                                                                        }
                                                                                        value={constructValue(item, ansItem)}
                                                                                        assessmentCompleted={assessmentCompleted}
                                                                                        placeholder={ansItem.answerText || ''}
                                                                                        isMandate={checkIsMandate(
                                                                                            ansItem?.answerInternalIdentifier,
                                                                                            assessmentData?.role,
                                                                                            memberLevelRule
                                                                                        )}
                                                                                        dynamicOptions={dynamicOptions}
                                                                                        setDynamicOptions={setDynamicOptions}
                                                                                        assessmentData={assessmentData}
                                                                                    />
                                                                                </>
                                                                            )
                                                                    )}
                                                            </Row>

                                                            {item.questionFooterTemplate && (
                                                                <div
                                                                    className="assessment-question-header"
                                                                    style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item.questionFooterTemplate
                                                                    }}
                                                                ></div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            ) : (
                                                <></>
                                                // <div
                                                //     className={`assessment-question-header ${hasTable ? 'override-table-styles' : ''}`}
                                                //     style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                                                //     dangerouslySetInnerHTML={{
                                                //         __html: item.questionHeaderTemplate
                                                //     }}
                                                // ></div>
                                            )}
                                        </>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    {queFooter && pageFooterContent()}
                </CardBody>
            </Card>
        );
    };

    const form = () => {
        return (
            <Card className={`m-4 ${displayPosition === 'right' ? 'arabic-text' : ''}`}>
                <CardBody className="mt-4">
                    {questionHeader() && pageHeaderWithName()}
                    {questionsData?.questions?.length > 0 &&
                        questionsData.questions.map((item, index) => {
                            const visibleQuestionNumber = getVisibleQuestionNumber(questionsData.questions, index);
                            return (
                                <React.Fragment key={index}>
                                    {checkVisibilityRule(item, questionRulesObj, assessmentData) && (
                                        <>
                                            {item?.answerControlType ? (
                                                <div className="custom-question-box-bg p-3 my-3 rounded-3">
                                                    <Label
                                                        className="form-label infoLabel"
                                                        style={displayPosition === 'right' ? { marginRight: '8px' } : {}}
                                                    >
                                                        {/* <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: `
									  <span style="margin-left: ${displayPosition === 'right' ? '12px' : '0'};">
										${item.qnId ?  ${visibleQuestionNumber} : ''}. ${item.questionText}
									  </span>
									`
                                                            }}
                                                        /> */}
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: `
                <span style="margin-left: ${displayPosition === 'right' ? '12px' : '0'};">
                    ${item.qnId ? `${visibleQuestionNumber}. ` : ''}
                    ${item.questionText}
                </span>
				`
                                                            }}
                                                        />
                                                    </Label>
                                                    <Label>
                                                        {item.isMandate ? <span class="text-danger">*</span> : ''}
                                                        {item?.questionInternalIdentifier !== 20 && shouldCheckLabel(item) && item.qnId
                                                            ? checkLabel(item)
                                                            : ''}
                                                    </Label>
                                                    {item?.nestedQuestions?.formType === 'table' ? (
                                                        <FormElements
                                                            key={index}
                                                            type={item?.nestedQuestions?.formType}
                                                            {...item}
                                                            changed={(e) => {
                                                                handleInputChange(e, item, index);
                                                            }}
                                                            handleOnBlur={(e) => {
                                                                if (assessmentCompleted) return;
                                                                else {
                                                                    return;
                                                                }
                                                                // handleOnBlurEvent();
                                                            }}
                                                            displayPosition={displayPosition}
                                                            data={item?.nestedQuestions}
                                                            disable={
                                                                assessmentCompleted ||
                                                                checkForDisableRules(item, null, answerLevelRulesObj, dropVal)
                                                            }
                                                            value={constructValue(item)}
                                                            updateTable={updateTable}
                                                            setUpdateTable={setUpdateTable}
                                                            assessmentData={assessmentData}
                                                        />
                                                    ) : item?.answerControlType === 103 || item.answerControlType === 120 ? (
                                                        <>
                                                            <Row className="g-3 mb-4 me-1">
                                                                <FormElements
                                                                    key={index}
                                                                    templateType={questionsData?.formType}
                                                                    type={item.answerControlType}
                                                                    {...item}
                                                                    changed={(e) => {
                                                                        handleInputChange(e, item, index);
                                                                    }}
                                                                    handleOnBlur={(e) => {
                                                                        if (assessmentCompleted) return;
                                                                        handleOnBlurEvent();
                                                                    }}
                                                                    displayPosition={displayPosition}
                                                                    disable={
                                                                        assessmentCompleted ||
                                                                        checkForDisableRules(item, null, answerLevelRulesObj, dropVal)
                                                                    }
                                                                    value={constructValue(item)}
                                                                    assessmentData={assessmentData}
                                                                />
                                                            </Row>
                                                            {item.questionFooterTemplate && (
                                                                <div
                                                                    className="assessment-question-header"
                                                                    style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item.questionFooterTemplate
                                                                    }}
                                                                ></div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Row className="g-3 me-2">
                                                                {item?.answers?.length > 0 &&
                                                                    item.answers.map(
                                                                        (ansItem) =>
                                                                            checkAnswerVisibleRule(
                                                                                assessmentData?.role,
                                                                                memberLevelRule,
                                                                                ansItem?.answerInternalIdentifier
                                                                            ) && (
                                                                                <>
                                                                                    <Label
                                                                                        style={
                                                                                            displayPosition === 'right'
                                                                                                ? { marginRight: '8px' }
                                                                                                : {}
                                                                                        }
                                                                                    >
                                                                                        {(ansItem?.answerHeaderText !== null ||
                                                                                            ansItem?.answerHeaderText !== '') &&
                                                                                            ansItem?.answerHeaderText}
                                                                                    </Label>
                                                                                    <FormElements
                                                                                        key={ansItem.answerId}
                                                                                        templateType={questionsData?.formType}
                                                                                        type={
                                                                                            ansItem.answerControlType ||
                                                                                            item.answerControlType
                                                                                        }
                                                                                        {...ansItem}
                                                                                        changed={(e, event) =>
                                                                                            handleInputChange(
                                                                                                e,
                                                                                                item,
                                                                                                index,
                                                                                                ansItem,
                                                                                                event
                                                                                            )
                                                                                        }
                                                                                        handleOnBlur={(isValid, type) => {
                                                                                            if (!assessmentCompleted) {
                                                                                                handleOnBlurEvent(isValid, type);
                                                                                            }
                                                                                        }}
                                                                                        displayPosition={displayPosition}
                                                                                        disable={
                                                                                            assessmentCompleted ||
                                                                                            checkForDisableRules(
                                                                                                item,
                                                                                                ansItem,
                                                                                                answerLevelRulesObj,
                                                                                                dropVal
                                                                                            )
                                                                                        }
                                                                                        value={constructValue(item, ansItem)}
                                                                                        assessmentCompleted={assessmentCompleted}
                                                                                        placeholder={ansItem.answerText || ''}
                                                                                        isMandate={checkIsMandate(
                                                                                            ansItem?.answerInternalIdentifier,
                                                                                            assessmentData?.role,
                                                                                            memberLevelRule
                                                                                        )}
                                                                                        assessmentData={assessmentData}
                                                                                    />
                                                                                </>
                                                                            )
                                                                    )}
                                                            </Row>

                                                            {item.questionFooterTemplate && (
                                                                <div
                                                                    className="assessment-question-header"
                                                                    style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item.questionFooterTemplate
                                                                    }}
                                                                ></div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            ) : (
                                                <div
                                                    className="assessment-question-header"
                                                    style={{ marginRight: displayPosition === 'right' ? '8px' : '' }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.questionHeaderTemplate
                                                    }}
                                                ></div>
                                            )}
                                        </>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    {queFooter && pageFooterContent()}
                </CardBody>
            </Card>
        );
    };

    const questionHeader = () => {
        return (
            selectedLanQns?.questionaireTemplate?.length > 0 &&
            selectedLanQns?.questionaireTemplate[currentIndexFromStore]?.pageHeaderTemplate
        );
    };

    const queFooter = () => {
        return (
            selectedLanQns?.questionaireTemplate?.length > 0 &&
            selectedLanQns?.questionaireTemplate[currentIndexFromStore]?.pageFooterTemplate
        );
    };

    const assessentFooter = () => {
        if (assessmentContent?.footerWithUrl) {
            return <div className="assessment-data-logo" dangerouslySetInnerHTML={{ __html: assessmentContent?.footerWithUrl }}></div>;
        } else {
            return <></>;
        }
    };
    const assessmentHeader = () => {
        return (
            <div
                className={
                    assessmentData?.assessmentInternalId === assessmentTypes?.AHC ? 'custom-assessment-logo' : 'assessment-data-logo'
                }
                dangerouslySetInnerHTML={{ __html: assessmentContent?.headerWithUrl }}
            ></div>
        );
    };
    const thankingContent = () => {
        let pageHeader = selectedLanQns?.confirmationPageContent?.replace('[FINDHELP]', findhelp || '');
        return (
            <div className="d-flex flex-column  align-items-center">
                <div className=" text-center" style={{ margin: '10px' }} dangerouslySetInnerHTML={{ __html: pageHeader }}></div>
                <Button onClick={handleDone}>{t('done')}</Button>
            </div>
        );
    };

    return (
        <>
            <div className="content-container bg-white">
                <NavbarComponent
                    language={selectedLan}
                    languagesList={languagesList}
                    changeLanguages={changeLanguage}
                    resetIndex={resetIndex}
                />

                {!loading ? assessmentHeader() : ''}
                {unavailable ? (
                    <Unavailable />
                ) : thankingPage ? (
                    thankingContent()
                ) : loading ? (
                    <Loader />
                ) : dataNotFound || isInActiveTemplate ? (
                    handleError()
                ) : assassmentCancelled ? (
                    <Error500 />
                ) : assessmentIdForBtn?.toString() === getConfig(assessmentIdForBtn)?.REACT_APP_ASSESSMENT_ID ? (
                    form()
                ) : (
                    formForAssessor()
                )}
                {!loading && assessentFooter()}
                {/* <EventLogger /> */}
                {!dataNotFound &&
                    !isInActiveTemplate &&
                    !assassmentCancelled &&
                    !thankingPage &&
                    !loading &&
                    !unavailable &&
                    !(
                        assessmentCompleted &&
                        assessmentTypes?.AHC === assessmentData?.assessmentInternalId &&
                        assessmentData?.responses?.length === 1
                    ) && (
                        <>
                            <ButtonComponent
                                currentIndexFromStore={currentIndexFromStore}
                                assessmentLength={assessmentLength}
                                handlePrev={handlePrev}
                                handleNext={handleNext}
                                handleAnswersSave={handleAssessmentSubmit}
                                assessmentCompleted={assessmentCompleted}
                                displayPosition={displayPosition}
                                showSubmitIfEmptyPage={showSubmitIfEmptyPage}
                                showApprove={isSam}
                                handleApproveOrReject={(type) => setConfirmPopup(type)}
                                isDemographic={assessmentIdForBtn}
                                completePage={handleRecall}
                                btnForMarriot={btnForMarriot}
                                nextToSubmit={nextToSubmit}
                                disableContinue={disableContinueBtn}
                            />
                        </>
                    )}
                {!loading && (
                    <>
                        <div className="my-5">&nbsp;</div>
                        <div className="text-center my-5">
                            <p className="">Survey by Assessor &#x2022; Powered by Implify™</p>
                            <p>Copyright© {new Date().getFullYear()} GroundGame.Health, all rights reserved.</p>
                        </div>
                        <div className="my-3">&nbsp;</div>
                    </>
                )}
            </div>

            {!!confirmPopup && (
                <ConfirmationPopup
                    show={confirmPopup === 'approve' || confirmPopup === 'reject'}
                    onCloseClick={() => setConfirmPopup('')}
                    handleSubmit={() => handleApproveOrReject(confirmPopup)}
                    disableSave={apiCalling}
                    loading={apiCalling}
                    confirmText={`Are sure want to ${confirmPopup} assessment ?`}
                    size={'md'}
                />
            )}
            {!!displayEligibilityConfirmation && (
                <CommonModal
                    show={!!displayEligibilityConfirmation}
                    headerText={t('confirm')}
                    bodyText={displayEligibilityConfirmation}
                    saveText={t('ok')}
                    handleSubmit={() => setDisplayEligibilityConfirmation('')}
                />
            )}
        </>
    );
}

export default Index;
